import type { LangMap } from "./index";

export const auth: LangMap = {
  en: {
    heroTitle: "Lumen — Your AI Tutor",
    heroSubtitle: "Your AI tutor for learning how to learn.",
    pleaseWait: "Please wait…",
    continueWithGoogle: "Continue with Google",
    continueWithApple: "Continue with Apple",
    orEmail: "or email",
    nameLabel: "Name",
    emailLabel: "Email",
    passwordLabel: "Password",
    createAccount: "Create my account",
    signIn: "Sign in",
    haveAccount: "Already have an account? Sign in",
    noAccount: "Don't have an account? Sign up",
    seePricingPrefix: "See our",
    pricingLink: "pricing",
    forgotPassword: "Forgot your password?",
    resetTitle: "Set a new password",
    newPassword: "New password",
    updatePassword: "Update password",
    backToSignIn: "Back to sign in",
    toasts: {
      resetSent: "We sent you an email with the link to reset your password.",
      passwordUpdated: "Password updated. You are signed in.",
      checkEmail: "Check your email to confirm your account, then sign in.",
      emailFirst: "Enter your email first.",
      accountCreated: "Account created! Let's start.",
      error: "Error",
      googleError: "Google error",
      appleError: "Apple error",
    },
  },
  it: {
    heroTitle: "Lumen — Il tuo tutor AI",
    heroSubtitle: "Il tuo tutor AI per imparare come imparare.",
    pleaseWait: "Attendi…",
    continueWithGoogle: "Continua con Google",
    continueWithApple: "Continua con Apple",
    orEmail: "oppure email",
    nameLabel: "Nome",
    emailLabel: "Email",
    passwordLabel: "Password",
    createAccount: "Crea il mio account",
    signIn: "Accedi",
    haveAccount: "Hai già un account? Accedi",
    noAccount: "Non hai un account? Registrati",
    seePricingPrefix: "Vedi i nostri",
    pricingLink: "prezzi",
    forgotPassword: "Password dimenticata?",
    resetTitle: "Imposta una nuova password",
    newPassword: "Nuova password",
    updatePassword: "Aggiorna password",
    backToSignIn: "Torna all'accesso",
    toasts: {
      resetSent: "Ti abbiamo inviato un'email con il link per reimpostare la password.",
      passwordUpdated: "Password aggiornata. Sei dentro.",
      checkEmail: "Controlla la tua email per confermare l'account, poi accedi.",
      emailFirst: "Inserisci prima la tua email.",
      accountCreated: "Account creato! Iniziamo.",
      error: "Errore",
      googleError: "Errore Google",
      appleError: "Errore Apple",
    },
  },
  es: {
    heroTitle: "Lumen — Tu tutor de IA",
    heroSubtitle: "Tu tutor de IA para aprender a aprender.",
    pleaseWait: "Espera…",
    continueWithGoogle: "Continuar con Google",
    continueWithApple: "Continuar con Apple",
    orEmail: "o email",
    nameLabel: "Nombre",
    emailLabel: "Correo electrónico",
    passwordLabel: "Contraseña",
    createAccount: "Crear mi cuenta",
    signIn: "Iniciar sesión",
    haveAccount: "¿Ya tienes una cuenta? Inicia sesión",
    noAccount: "¿No tienes una cuenta? Regístrate",
    seePricingPrefix: "Consulta nuestros",
    pricingLink: "precios",
    forgotPassword: "¿Olvidaste tu contraseña?",
    resetTitle: "Establece una nueva contraseña",
    newPassword: "Nueva contraseña",
    updatePassword: "Actualizar contraseña",
    backToSignIn: "Volver al inicio de sesión",
    toasts: {
      resetSent: "Te enviamos un email con el enlace para restablecer tu contraseña.",
      passwordUpdated: "Contraseña actualizada. Ya has iniciado sesión.",
      checkEmail: "Revisa tu email para confirmar la cuenta y luego inicia sesión.",
      emailFirst: "Introduce primero tu email.",
      accountCreated: "¡Cuenta creada! Empecemos.",
      error: "Error",
      googleError: "Error de Google",
      appleError: "Error de Apple",
    },
  },
  fr: {
    heroTitle: "Lumen — Votre tuteur IA",
    heroSubtitle: "Votre tuteur IA pour apprendre à apprendre.",
    pleaseWait: "Veuillez patienter…",
    continueWithGoogle: "Continuer avec Google",
    continueWithApple: "Continuer avec Apple",
    orEmail: "ou email",
    nameLabel: "Nom",
    emailLabel: "Email",
    passwordLabel: "Mot de passe",
    createAccount: "Créer mon compte",
    signIn: "Se connecter",
    haveAccount: "Vous avez déjà un compte ? Connectez-vous",
    noAccount: "Vous n'avez pas de compte ? Inscrivez-vous",
    seePricingPrefix: "Consultez nos",
    pricingLink: "tarifs",
    forgotPassword: "Mot de passe oublié ?",
    resetTitle: "Définir un nouveau mot de passe",
    newPassword: "Nouveau mot de passe",
    updatePassword: "Mettre à jour le mot de passe",
    backToSignIn: "Retour à la connexion",
    toasts: {
      resetSent: "Nous vous avons envoyé un email avec le lien de réinitialisation.",
      passwordUpdated: "Mot de passe mis à jour. Vous êtes connecté.",
      checkEmail: "Vérifiez votre email pour confirmer le compte, puis connectez-vous.",
      emailFirst: "Saisissez d'abord votre email.",
      accountCreated: "Compte créé ! Commençons.",
      error: "Erreur",
      googleError: "Erreur Google",
      appleError: "Erreur Apple",
    },
  },
  de: {
    heroTitle: "Lumen — Dein KI-Tutor",
    heroSubtitle: "Dein KI-Tutor, um lernen zu lernen.",
    pleaseWait: "Bitte warten…",
    continueWithGoogle: "Mit Google fortfahren",
    continueWithApple: "Mit Apple fortfahren",
    orEmail: "oder E-Mail",
    nameLabel: "Name",
    emailLabel: "E-Mail",
    passwordLabel: "Passwort",
    createAccount: "Mein Konto erstellen",
    signIn: "Anmelden",
    haveAccount: "Bereits ein Konto? Anmelden",
    noAccount: "Noch kein Konto? Registrieren",
    seePricingPrefix: "Siehe unsere",
    pricingLink: "Preise",
    forgotPassword: "Passwort vergessen?",
    resetTitle: "Neues Passwort festlegen",
    newPassword: "Neues Passwort",
    updatePassword: "Passwort aktualisieren",
    backToSignIn: "Zurück zur Anmeldung",
    toasts: {
      resetSent: "Wir haben dir eine E-Mail mit dem Link zum Zurücksetzen geschickt.",
      passwordUpdated: "Passwort aktualisiert. Du bist angemeldet.",
      checkEmail: "Bestätige dein Konto per E-Mail und melde dich dann an.",
      emailFirst: "Gib zuerst deine E-Mail ein.",
      accountCreated: "Konto erstellt! Los geht's.",
      error: "Fehler",
      googleError: "Google-Fehler",
      appleError: "Apple-Fehler",
    },
  },
  pt: {
    heroTitle: "Lumen — Seu tutor de IA",
    heroSubtitle: "Seu tutor de IA para aprender a aprender.",
    pleaseWait: "Aguarde…",
    continueWithGoogle: "Continuar com Google",
    continueWithApple: "Continuar com Apple",
    orEmail: "ou e-mail",
    nameLabel: "Nome",
    emailLabel: "E-mail",
    passwordLabel: "Senha",
    createAccount: "Criar minha conta",
    signIn: "Entrar",
    haveAccount: "Já tem uma conta? Entrar",
    noAccount: "Não tem uma conta? Cadastre-se",
    seePricingPrefix: "Veja nossos",
    pricingLink: "preços",
    forgotPassword: "Esqueceu a senha?",
    resetTitle: "Definir uma nova senha",
    newPassword: "Nova senha",
    updatePassword: "Atualizar senha",
    backToSignIn: "Voltar ao login",
    toasts: {
      resetSent: "Enviamos um e-mail com o link para redefinir sua senha.",
      passwordUpdated: "Senha atualizada. Você está conectado.",
      checkEmail: "Confirme sua conta pelo e-mail e depois entre.",
      emailFirst: "Digite primeiro o seu e-mail.",
      accountCreated: "Conta criada! Vamos começar.",
      error: "Erro",
      googleError: "Erro do Google",
      appleError: "Erro da Apple",
    },
  },
};
